import { isInStock } from "../../utils/isInStock";
export const getOptionsForColorSelector = (config, isColorValue = true, stock) => config.map((data) => ({
    label: data.label,
    value: isColorValue ? data.swatchData : data.id,
    additionalData: data,
    color: data.swatchData,
    isInStock: stock ? data.sku !== undefined && isInStock(stock[data.sku]) : true,
}));
export const getOptionsForColorSelectorById = (config, isColorValue = true, stock) => config.map((data) => ({
    label: data.label,
    value: isColorValue ? data.swatchData : data.id,
    additionalData: data,
    color: data.swatchData,
    isInStock: stock ? data.id !== undefined && isInStock(stock[data.id]) : true,
}));
//# sourceMappingURL=getOptionsForColorSelector.js.map